import { JobQueue } from "./jobQueue";

export type JobQueueActions =
  { type: JobQueueAction.CloseAddQueueModal } |
  { type: JobQueueAction.CloseDeleteQueueModal } |
  { type: JobQueueAction.LoadQueues } |
  { type: JobQueueAction.QueueDeleted, id: number } |
  { type: JobQueueAction.QueuesLoaded, result: JobQueue[] } |
  { type: JobQueueAction.QueueUpdated, queue: JobQueue } |
  { type: JobQueueAction.ShowAddQueueModal } | 
  { type: JobQueueAction.ShowDeleteQueueModal, queue: JobQueue } |
  { type: JobQueueAction.UpdateFallbackQueue, queue: JobQueue }

export enum JobQueueAction {
  CloseAddQueueModal = "CLOSE_ADD_QUEUE_MODAL",
  CloseDeleteQueueModal = "CLOSE_DELETE_QUEUE_MODAL",
  LoadQueues = "LOAD_QUEUES",
  QueueDeleted = "QUEUE_DELETED",
  QueuesLoaded = "QUEUES_LOADED",
  QueueUpdated = "QUEUE_UPDATED",
  ShowAddQueueModal = "SHOW_ADD_QUEUE_MODAL",
  ShowDeleteQueueModal = "SHOW_DELETE_QUEUE_MODAL",
  UpdateFallbackQueue = "UPDATE_FALLBACK_QUEUE"
}